import { StandardAction } from './standard-action';

export class InfoAction extends StandardAction {
  public italic = false;
  public fontSize = 13;
  public override bold = false;
  public override category = 'info';

  constructor(
    name: string,
    text: string,
    icon?: string,
    tooltip?: string,
    settings?: {
      italic?: boolean;
      fontSize?: number;
      bold?: boolean;
      align?: 'right' | 'left';
    }
  ) {
    super(name, icon, text, tooltip);
    if (settings) {
      this.setSettings(settings);
    }
  }

  private setSettings(settings: {
    italic?: boolean;
    fontSize?: number;
    bold?: boolean;
    align?: 'right' | 'left';
  }) {
    if (settings.italic !== undefined) {
      this.italic = settings.italic;
    }
    if (settings.bold !== undefined) {
      this.bold = settings.bold;
    }
    if (settings.fontSize) {
      this.fontSize = settings.fontSize;
    }
    if (settings.align === 'right' || settings.align === 'left') {
      this.align = settings.align;
    }
  }

  override getActionType(): string {
    return 'info';
  }
}
